import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const OverPaying = () => {
  return (
    <section className="px-3 py-5 bg-black lg:py-10">
      <div className="container px-12 mx-auto">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 50,
            },
          }}
          modules={[Pagination]}
          className="overpayingSlider"
        >
          <SwiperSlide>
            <div className="grid lg:grid-cols-2 gap-5">
              <div className="order-2 lg:order-1 flex flex-col justify-center items-start">
                <p className="text-5xl font-bold md:text-5xl text-primary">
                  Are you overpaying your bank?
                </p>
                <p className="mt-2 text-white text-sm md:text-lg">
                  Banks often advertise free or low-cost transfers, but add a
                  hidden markup to the exchange rate. Wise gives you the real,
                  mid-market, exchange rate, so you can make huge savings on
                  your{" "}
                  <span className="text-primary underline">
                    international money transfers.
                  </span>
                </p>
              </div>
              <div className="order-1 lg:order-2">
                <img
                  className=" object-cover  ms-auto"
                  src="/assets/images/overpayingImg.png"
                  alt=""
                />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="grid lg:grid-cols-2 gap-5">
              <div className="order-2 lg:order-1 flex flex-col justify-center items-start">
                <p className="text-5xl font-bold md:text-5xl text-primary">
                  Are you overpaying your bank?
                </p>
                <p className="mt-2 text-white text-sm md:text-lg">
                  Banks often advertise free or low-cost transfers, but add a
                  hidden markup to the exchange rate. Wise gives you the real,
                  mid-market, exchange rate, so you can make huge savings on
                  your{" "}
                  <span className="text-primary underline">
                    international money transfers.
                  </span>
                </p>
              </div>
              <div className="order-1 lg:order-2">
                <img
                  className=" object-cover  ms-auto"
                  src="/assets/images/overpayingImg.png"
                  alt=""
                />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="grid lg:grid-cols-2 gap-5">
              <div className="order-2 lg:order-1 flex flex-col justify-center items-start">
                <p className="text-5xl font-bold md:text-5xl text-primary">
                  Are you overpaying your bank?
                </p>
                <p className="mt-2 text-white text-sm md:text-lg">
                  Banks often advertise free or low-cost transfers, but add a
                  hidden markup to the exchange rate. Wise gives you the real,
                  mid-market, exchange rate, so you can make huge savings on
                  your{" "}
                  <span className="text-primary underline">
                    international money transfers.
                  </span>
                </p>
              </div>
              <div className="order-1 lg:order-2">
                <img
                  className=" object-cover  ms-auto"
                  src="/assets/images/overpayingImg.png"
                  alt=""
                />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default OverPaying;
